import React, { Suspense } from 'react';
import { HashRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import LoginForm from "pages/login/LoginForm";
import NotFound from "pages/404/NotFound"; 
import ErrorBoundary from "./ErrorBoundary"; // Importa el Error Boundary 
import store from "store/Store";
import "./App.css";
import Home from "pages/main/Home";   
import Terms from "pages/main/Terms";
import Privacity from "pages/main/Privvacity";
import HomeStore from "pages/stores/HomeStore";
import HomeEmployee from 'pages/employees/HomeEmployee';
import HomeDriver from "pages/driver/HomeDriver";
import HomeDriverEditData from "pages/driver/HomeDriverEditData";
import HomeStoreEditData from "pages/stores/HomeStoreEditData";
import HomeEmployeeEditData from "pages/employees/HomeEmployeeEditData";
import HomeFormDI from "pages/forms/filterFormDI/HomeFormDI";
import HomeFormEditData from "pages/forms/editOrNewFormDI/HomeFormEditData";
import HomeTypesDIEditData from "pages/typesDIFormat/HomeTypesDIEditData";
import HomeTypesDI from "pages/typesDIFormat/HomeTypesDI";
import HomeContract from "pages/contracts/HomeContract";
import HomeContractSendEmail from "pages/contracts/contractSendEmail/HomeContractSendEmail";
import HomeContractEditData from "pages/contracts/editOrNewContract/HomeContractEditData";
import HomeShippng from "pages/shipping/HomeShipping";
import HomeShippingSendEmail from "pages/shipping/shippingSendEmail/HomeShippingSendEmail";
import HomeShippingDeCA from "pages/shipping/deca/HomeShippingDeCA";
import HomeFormDIDeCA from "pages/forms/deca/HomeFormDIDeCA";
import HomeShippingSendEmailList from  "pages/shipping/sippingSendEmailList/HomeShippingSendEmailList";
import HomeShippingEditData from "pages/shipping/editOrNewShipping/HomeShippingEditData";
import HomeRegisterBook from "pages/registerBook/HomeRegisterBook";
import HomeReceivedEmail from "pages/recievedemails/HomeReceivedEmail";
import HomeSentEmail from "pages/sentemails/HomeSentEmail";
import HomeFormDISendEmail from "pages/forms/formDISendEmail/HomeFormDISendEmail";
import HomeFormDISignatureEditData from "pages/forms/editFormDISignatureSign/HomeFormDISIgnatureEditData";
import HomeFormDISendESIR from "pages/forms/esirFormDI/HomeFormDISendESIR";
import HomeNT from "pages/NT/filterNT/HomeNT";
import HomeNTEditData from "pages/NT/editOrCreateNT/HomeNTEditData";
import HomeNTSendEmail from "pages/NT/NTSendEmail/HomeNTSendEmail";
import HomeNTSendESIR from "pages/NT/esirNT/HomeNTSendESIR";
import NTSendESIRCERT from "pages/NT/esirNTSendCERT/HomeNTSendESIRCERT";
import HomeSentIncident from "pages/sentincidents/HomeSentIncident";
import HomeSentIncidentEditData from "pages/sentincidents/editOrNewIncidentEmail/HomeSentIncidentEditData";
import HomeFormDISendEmailList from "pages/forms/formDISendEmailList/HomeFormDISendEmailList";
import HomeSentIncidentFormDIEditData from "pages/forms/formDICreateInicident/HomeFormDiSentIncident";
import HomeArticle from "pages/articles/HomeArticle";
import HomeArticleEditData from "pages/articles/articleEditOrCreate/HomeArticleEditData"; 
import HomeSHEETEditData from "pages/sheet/editOrCreateSheet/HomeSHEETEditData";
import HomeSHEET from "pages/sheet/filterSHEET/HomeSHEET";
import HomePurchaseDelivery from "pages/purchases/HomePurchaseDelivery";
import HomePurchaseDeliveryEditData from "pages/purchases/editOrNewPurchaseDelivery/HomePurchaseDeliveryEditData";
import HomePurchaseDeliverySendEmail from "pages/purchases/purchaseDeliverySendEmail/HomePurchaseDeliverySendEmail"

const App =() => {  
  return(
    
    <Provider store={store}>
      <div className="App">
        <ErrorBoundary>  
          <Suspense fallback={null}>
            <section className="App-content">            
              <HashRouter>
                <Routes>
                  <Route path="" element={<LoginForm key="login" />} />
                  <Route path="/*" element={<NotFound key="notfound" />} />
                  <Route path="/home" element={<Home key="home" />} />
                  <Route path="/terms" element={<Terms key="terms" />} />
                  <Route path="/privacity" element={<Privacity key="privacity" />} />
                  <Route path="/store" element={<HomeStore key="store"/>} />
                  <Route path="/storedetail/:id" element={ <HomeStoreEditData key="storedetail"/> } /> 
                  <Route path="/nt" element={<HomeNT key="nt" typeList="1"/>} />
                  <Route path="/nthome" element={<HomeNT key="nthome" typeList="2"/>} />
                  <Route path="/ntdetail/:id" element={<HomeNTEditData key="ntdetail" typeList="1"/>} />
                  <Route path="/ntdetailhome/:id" element={<HomeNTEditData key="ntdetailhome" typeList="2"/>} />
                  <Route path="/ntsendemail/:id" element={<HomeNTSendEmail key="ntsendemail" />} />
                  <Route path="/ntsendesirended/:id" element={<HomeNTSendESIR key="ntsendesirended" />} />
                  <Route path="/ntsendesirendedcert/:id" element={<NTSendESIRCERT key="ntsendesirendedcert" />} /> 
                  <Route path="/contract" element={<HomeContract key="contract" />} />
                  <Route path="/contractdetail/:id" element={<HomeContractEditData key="contractdetail"/>} />
                  <Route path="/contactemail/:id" element={<HomeContractSendEmail key="contactemail" />} />
                  <Route path="/formdi" element={<HomeFormDI key="formdi" typeList="1"/>} />
                  <Route path="/formdiended" element={<HomeFormDI key="formdiended" typeList="2"/>} />
                  <Route path="/formdetail/:id" element={<HomeFormEditData key="formdetail" typeList="1"/>} />
                  <Route path="/formdetail2/:id" element={<HomeFormEditData key="formdetail2" typeList="2"/>} />

                  <Route path="/formdetailsignature/:id" element={<HomeFormDISignatureEditData key="formdetailsignature" typeList="1"/>} />
                  <Route path="/formdetailsignature2/:id" element={<HomeFormDISignatureEditData key="formdetailsignature2" typeList="2"/>} />
                  <Route path="/formdisendemail/:id" element={<HomeFormDISendEmail key="formdisendemail" typeList="1"/>} />
                  <Route path="/formdisendemailended/:id" element={<HomeFormDISendEmail key="formdisendemailended" typeList="2"/>} />
                  <Route path="/formdisendesir/:id" element={<HomeFormDISendESIR key="formdisendesir" typeList="1"/>} />
                  <Route path="/formdisendesirended/:id" element={<HomeFormDISendESIR key="formdisendesirended" typeList="2"/>} />
                  <Route path="/formdisendemaillist/:getData" element={<HomeFormDISendEmailList key="formdisendemaillist"  typeList="1"/>} />
                  <Route path="/formdisendemaillistended/:getData" element={<HomeFormDISendEmailList key="formdisendemaillistended"  typeList="2"/>} />
                  <Route path="/formdisendemailincidentlist/:id" element={<HomeSentIncidentFormDIEditData key="formdisendemailincidentlist"  typeList="1"/>} />
                  <Route path="/formdisendemailincidentlistended/:id" element={<HomeSentIncidentFormDIEditData key="formdisendemailincidentlistended"  typeList="2"/>} />
                  <Route path="/formdideca/:id" element={<HomeFormDIDeCA key="formdideca" typeList="1" />} />
                  <Route path="/formdidecaended/:id" element={<HomeFormDIDeCA key="formdidecaended" typeList="2" />} />
                  <Route path="/formatdi" element={<HomeTypesDI key="formatdi" />} />
                  <Route path="/formatdidetail/:id" element={<HomeTypesDIEditData key="formatdidetail"/>} /> 
                  <Route path="/employee" element={<HomeEmployee key="employee" />} />
                  <Route path="/employeedetail/:id" element={<HomeEmployeeEditData key="employeedetail"/>} />
                  <Route path="/driver" element={<HomeDriver key="driver" />} />
                  <Route path="driverdetail/:id" element={<HomeDriverEditData key="driverdetail" />} />          
               
                  <Route path="/shipping" element={<HomeShippng key="shipping"  typeList="1"/>} />
                  <Route path="/shippingended" element={<HomeShippng key="shippingended"  typeList="2"/>} />
                  <Route path="/shippingbegin" element={<HomeShippng key="shippingbegin"  typeList="3"/>} />
                  
                  <Route path="/shippingemail/:id" element={<HomeShippingSendEmail key="shippingemail" typeList="1" />} /> 
                  <Route path="/shippingemailended/:id" element={<HomeShippingSendEmail key="shippingemailended" typeList="2"/>} /> 
                  <Route path="/shippingemailbegin/:id" element={<HomeShippingSendEmail key="shippingemailbegin" typeList="3"/>} /> 

                  <Route path="/shippingdeca/:id" element={<HomeShippingDeCA key="shippingdeca" typeList="1" />} />
                  <Route path="/shippingdecaended/:id" element={<HomeShippingDeCA key="shippingdecaended" typeList="2" />} />
                  <Route path="/shippingdecabegin/:id" element={<HomeShippingDeCA key="shippingdecabegin" typeList="3" />} />
                  
                  <Route path="/shippinglistsendemaillist" element={<HomeShippingSendEmailList key="shippinglistsendemaillist"  typeList="1"/>} />
                  <Route path="/shippinglistsendemaillistended" element={<HomeShippingSendEmailList key="shippinglistsendemaillistended"  typeList="2"/>} />
                  <Route path="/shippinglistsendemaillistbegin" element={<HomeShippingSendEmailList key="shippinglistsendemaillistbegin"  typeList="3"/>} />
                  
                  <Route path="/shippingdetail/:id" element={<HomeShippingEditData key="shippingdetail" typeList="1"/>} />
                  <Route path="/shippingdetailended/:id" element={<HomeShippingEditData key="shippingdetailended" typeList="2"/>} />
                  <Route path="/shippingdetailhome/:id" element={<HomeShippingEditData key="shippingdetailhome" typeList="3"/>} /> 
               
                  <Route path="/receivedemails" element={<HomeReceivedEmail key="receivedemails" />} />
                  <Route path="/registerbook" element={<HomeRegisterBook key="registerbook" />} />
                  <Route path="/sentemails" element={<HomeSentEmail key="sentemails" />} /> 
                  <Route path="/incidentemail" element={<HomeSentIncident key="incidentemail" />} />
                  <Route path="/sentincidentemail/:id" element={<HomeSentIncidentEditData key="sentincidentemail" />} />     
                  <Route path="/article" element={<HomeArticle key="article"/>} />
                  <Route path="/articledetail/:id" element={<HomeArticleEditData key="articledetail" />} /> 

                  <Route path="/sheet" element={<HomeSHEET key="sheet" typeList="1"/>} />
                  <Route path="/sheetended" element={<HomeSHEET key="sheetended" typeList="2"/>} />
                  <Route path="/sheetdetail/:id" element={<HomeSHEETEditData key="sheetdetail" typeList="1"/>} />
                  <Route path="/sheetdetailhome/:id" element={<HomeSHEETEditData key="sheetdetailhome" typeList="2"/>} />
                     
                  <Route path="/purchasedeliveryin" element={<HomePurchaseDelivery key="purchasedeliveryin" typeList="1"/>} />
                  <Route path="/purchasedeliveryout" element={<HomePurchaseDelivery key="purchasedeliveryout" typeList="2"/>} /> 
                  <Route path="/purchasedeliverydetailin/:id" element={<HomePurchaseDeliveryEditData key="purchasedeliverydetailin" typeList="1"/>} />
                  <Route path="/purchasedeliverydetailout/:id" element={<HomePurchaseDeliveryEditData key="purchasedeliverydetailout" typeList="2"/>} />

                  <Route path="/purchasedeliverysendemailin/:id" element={<HomePurchaseDeliverySendEmail key="purchasedeliverysendemailin" typeList="1"/>} />
                  <Route path="/purchasedeliverysendemailout/:id" element={<HomePurchaseDeliverySendEmail key="purchasedeliverysendemailout" typeList="2"/>} />

             
                </Routes>
              </HashRouter>
            </section>
          </Suspense>
        </ErrorBoundary>
      </div>
    </Provider>
  );
};

export default App;
